module.exports = __webpack_public_path__ + "static/media/status.a1281bd1.jpg";